import queryString from "query-string";
import React, { PureComponent } from "react";

import { asyncState, validNumber } from "@utils/calculators";

import {
    CALCULATOR_KEYS,
    trackCalculatorStepStarted,
    trackCalculatorStepSubmitted,
} from "@services/tracking";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type State = {
    roofLength: number;
    roofWidth: number;
    roofArea: number;
};

class RoofingCalculator extends PureComponent<{}, State> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);
        this.state = {
            roofLength: this.query.roofLength ? Number(this.query.roofLength) : 0,
            roofWidth: this.query.roofWidth ? Number(this.query.roofWidth) : 0,
            roofArea: 0,
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            roofArea: this.roofArea(),
        });

        trackCalculatorStepStarted(CALCULATOR_KEYS.roofing);
    }

    roofArea = () => {
        let roofArea = 0;
        // @ts-ignore
        const roofLength = parseFloat(this.state.roofLength);
        // @ts-ignore
        const roofWidth = parseFloat(this.state.roofWidth);

        if (validNumber(roofLength) && validNumber(roofWidth)) {
            roofArea = roofLength * roofWidth;
        }

        return Number(roofArea);
    };
    
    setCalculationValue = (field: string, value: number) =>
        // @ts-ignore
        this.setState({ [field]: value }, () => {
            this.setState({ roofArea: this.roofArea() });

            // @ts-ignore
            trackCalculatorStepSubmitted(CALCULATOR_KEYS.roofing);
        });

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            // @ts-ignore
            roofLength: this.state.roofLength,
            // @ts-ignore
            roofWidth: this.state.roofWidth,
        };
        const resultProps = {
            // @ts-ignore
            roofArea: this.state.roofArea,
            mailParams: {
                // @ts-ignore
                roofLength: this.state.roofLength,
                // @ts-ignore
                roofWidth: this.state.roofWidth,
            },
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { RoofingCalculator };
